<template>
  <div class="layout-wrapper">
    <layout-header style="height:80px;"></layout-header>
    <layout-main></layout-main>
    <layout-sidebar></layout-sidebar>
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import Header from './components/Header'
import Main from './components/Main'
import Sidebar from './components/Sidebar'
import Footer from './components/Footer'

export default {
  name: 'Layout',
  components: {
    LayoutHeader: Header,
    LayoutMain: Main,
    LayoutSidebar: Sidebar,
    LayoutFooter: Footer,
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
.layout-wrapper {
  background-color: #fff;
}
</style>
